// react
import { useContext } from 'react';

// mui
import { Grid, Paper } from '@mui/material';

// tables
import { TableBasicSoe } from '../../../../../tables/basic/TableBasicSoe/TableBasicSoe';

// context
import { ContextSoeTransactions } from '../Soe.context';

// ui
import { TableFooter } from '../../../../../ui/TableFooter/TableFooter';

export const Details = () => {
	// context
	const { getTransactions, headerSelections, isLoading, pagination, transactions } =
		useContext(ContextSoeTransactions);

	// get visible header keys
	const headersVisible = headerSelections.filter((h) => h.checked).map((h) => h.key);

	return (
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<Paper>
					<TableBasicSoe
						data={transactions}
						headersVisible={headersVisible}
						isLoading={isLoading}
					/>
				</Paper>
			</Grid>
			<Grid item xs={12}>
				<TableFooter
					hasSelectRows={true}
					numShowing={transactions.length}
					onChangePage={(e, page) => {
						getTransactions({
							pagination: {
								...pagination,
								page,
							},
						});
					}}
					onChangeRowsPerPage={(e) => {
						getTransactions({
							pagination: {
								...pagination,
								perPage: Number(e.target.value),
							},
						});
					}}
					pagination={pagination}
				/>
			</Grid>
		</Grid>
	);
};
